// Libs
import axios from 'axios';

// Actions
import { changeLocalLoading, changeErr } from '../App/actions'
import { changeAuth, changeUserField, changeFormType, changeQrcode } from '../Auth/actions'
import { changePopUp } from '../PopUp/actions'
import { daysDifference } from '../../constants/validate'

// Axios
import { serverAPI, reportAPI, searchAPI } from '../../index'

// Action types
export const SIGN_IN = 'sign_in'

export function signIn({ email, password, type, lastPathname, history = null }) {
  return function (dispatch) {
    dispatch(changeLocalLoading(true))
    return serverAPI.post('/user/sign-in', { email, password })
      .then(response => {
        dispatch(changeLocalLoading(false))
        let data = response.data
        const { id, token, role } = data

        // Add image URL
        data = { ...data, image: `https://server.semprocesso.com.br/user/image/${token}/${id}/${Math.random()}` }

        // Remove user data in local storage
        let oldWidget = localStorage.getItem('user-widget')
        localStorage.clear()
        localStorage.setItem('user-widget',oldWidget)

        Object.keys(data).forEach(key => {
          // Set data in localStorage/store
          dispatch(changeUserField({ key, value: data[key] }))
        });

        dispatch(changeAuth(true))

        // Set default headers for request
        serverAPI.defaults.headers['X-Auth-Token'] = token;
        reportAPI.defaults.headers['X-Auth-Token'] = token;
        searchAPI.defaults.headers['X-Auth-Token'] = token;

        // Need to change password if its the temporary password
        if (data.temporary || type === 'forget-password') {
          dispatch(changePopUp(true, 'change password'))
        }
        else {
          if (data.groupExpiredPassword && !data.admin) {
            if (data.updatedPassword === null || daysDifference(data.updatedPassword) >= 90) {
              dispatch(changePopUp(true, 'amil'))
            }
          }
        }

        // Redirect to
        switch (type) {
          case 'invite':
          case 'invite-b':
          case 'invite-c':
            history.push('/tour/0')
            break;
          case 'sign-up':
            history.push('/tour/1')
            break;
          default:
            if (role === 'lawyer') {
              history.push('/meus-casos')
            } else if (role === 'company') {
              // document.location.href = '/dashboard'
              history.push('/dashboard')
            }
        }
        dispatch(changeFormType('login'))
      })
      .catch((e) => {
        dispatch(changeLocalLoading(false))
        switch (e.response.status) {
          case 401:
            dispatch(changeErr('Usuário bloqueado. Entre em contato com nossa equipe de suporte através do chat'))
            break
          case 403:
            dispatch(changeErr('Usuário excedeu o número de tentativas. Em alguns minutos tente novamente.'))
            break
          case 404:
            dispatch(changeErr('Usuário e/ou senha inválidos'))
            break
          default:
            dispatch(changeErr('Desculpe, os servidores estão em manutenção no momento. Em algumas horas iremos retomar as atividades'))
        }
      })
  }
}

export function verifySignIn({ email, password, type, lastPathname, history }) {
  return function (dispatch) {
    dispatch(changeLocalLoading(true))
    return serverAPI.post('/user/verify-sign-in', { email, password })
      .then(response => {
        let { doubleAuth, qrcode } = response.data
        if (!doubleAuth) {
          dispatch(signIn({ email, password, type, lastPathname, history }))
        }
        else {
          dispatch(changeLocalLoading(false))
          dispatch(changeQrcode(qrcode))
          dispatch(changeFormType('doubleAuth'))
        }
      }).catch(e => {
        dispatch(changeLocalLoading(false))
        switch (e.response.status) {
          case 401:
            dispatch(changeErr('Usuário bloqueado. Entre em contato com nossa equipe de suporte através do chat'))
            break
          case 403:
            dispatch(changeErr('Usuário excedeu o número de tentativas. Em alguns minutos tente novamente.'))
            break
          case 404:
            dispatch(changeErr('Usuário e/ou senha inválidos'))
            break
          default:
            dispatch(changeErr('Desculpe, os servidores estão em manutenção no momento. Em algumas horas iremos retomar as atividades'))
        }
      })
  }
}

export function verifyDoubleAuth({ email, password, type, lastPathname, code, history }) {
  return function (dispatch) {
    dispatch(changeLocalLoading(true))
    return serverAPI.post('/user/verify-double-auth', { code, email })
      .then(response => {
        dispatch(signIn({ email, password, type, lastPathname, history }))
      }).catch(e => {
        dispatch(changeLocalLoading(false))
        switch (e.response.status) {
          case 406:
            dispatch(changeErr('Código incorreto'))
            break
          default:
            dispatch(changeErr('Desculpe, os servidores estão em manutenção no momento. Em algumas horas iremos retomar as atividades'))
        }
      })
  }
}
